import { put, takeLatest } from 'redux-saga/effects';
import {
  GET_APPLICATION,
  GET_APPLICATION_SUCCESS,
  GET_APPLICATIONS,
  GET_APPLICATIONS_SUCCESS,
  GET_VARIANT_GROUPS,
  GET_VARIANT_GROUPS_SUCCESS,
} from '@/store/types/application';
import { onFailRequest } from '@/utils';
import { requestGetApplications } from '@/store/requests/application';
import { requestGetVariantGroups } from '@/store/requests/variant';

/**
 * save application
 * @param {*} payload
 */
function* requestApplication({ data }) {
  yield put({ type: GET_APPLICATION_SUCCESS, payload: data });
}

/**
 * get applications
 */
function* getApplications() {
  try {
    const { data } = yield requestGetApplications();
    yield put({ type: GET_APPLICATIONS_SUCCESS, payload: data });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
    });
  }
}

function* getVariantGroups() {
  try {
    const { data } = yield requestGetVariantGroups();
    yield put({ type: GET_VARIANT_GROUPS_SUCCESS, payload: data });
  } catch (error) {
    yield onFailRequest({ error });
  }
}

export default [
  takeLatest(GET_APPLICATION, requestApplication),
  takeLatest(GET_APPLICATIONS, getApplications),
  takeLatest(GET_VARIANT_GROUPS, getVariantGroups),
];
